// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/welcome-frontend/" + {"220":"P6Bx","235":"uurv","380":"yaP1","382":"K_VX","410":"PzS-","450":"mf3M","458":"os6v"}[chunkId] + "-" + {"220":"5667672f98af","235":"fde2c4cd8596","380":"648be7b47c47","382":"b92af557c992","410":"6d4e4fe910f3","450":"09247a8ad727","458":"92fc7f22aa12"}[chunkId] + ".css";
};